import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/colorpicker.styles'
import ColorTicket from './ColorTicket'
import combinations from './assets/meta/Colors'

const useStyles = makeStyles(styles)

export default function ColorPicker({ handleChange, index }) {
    const classes = useStyles()
    return (
        <div >
            <h3 className={classes.h3} >Scegli un colore</h3>
            <div className={classes.wrapper} >
                {combinations.map((e, i) => <ColorTicket
                    key={i}
                    handleChange={handleChange}
                    active={i === index}
                    name={e.name}
                    index={i}
                    img={e.src} />
                )}
            </div>
        </div>
    )
}
